"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _icons = require("../../assets/icons");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
(function _() {
  var styles = ".Modal {\n  position: fixed;\n  margin: 5rem auto auto auto;\n  border: none;\n  border-radius: 3px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n.Modal::backdrop {\n  background-color: rgba(0, 0, 0, 0.4);\n  cursor: pointer;\n}\n.Modal__container {\n  max-width: 100%;\n  padding: 3rem;\n}\n.Modal__close {\n  cursor: pointer;\n  align-self: flex-end;\n  background: none;\n  border: none;\n  padding: 0;\n}\n.Modal__close__container {\n  position: relative;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  top: -2rem;\n  left: 2rem;\n  margin-bottom: -2rem;\n}";
  var fileName = "Modal_Modal";
  var element = document.querySelector("style[data-sass-component='Modal_Modal']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var Modal = function Modal(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    modalOpen = _ref.modalOpen;
  var dialogRef = (0, _react.useRef)(null);
  var outsideModal;
  (0, _react.useLayoutEffect)(function () {
    if (isOpen) {
      var _dialogRef$current;
      dialogRef == null ? void 0 : (_dialogRef$current = dialogRef.current) == null ? void 0 : _dialogRef$current.showModal();
    } else {
      var _dialogRef$current2;
      dialogRef == null ? void 0 : (_dialogRef$current2 = dialogRef.current) == null ? void 0 : _dialogRef$current2.close();
    }
  }, [isOpen]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("dialog", {
    className: "Modal ".concat(className),
    ref: dialogRef,
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Escape') {
        modalOpen(false);
      }
    },
    onMouseOverCapture: function onMouseOverCapture(e) {
      if (e.target === dialogRef.current) {
        outsideModal = true;
      } else {
        outsideModal = false;
      }
    },
    onClick: function onClick(e) {
      e.stopPropagation();
      if (outsideModal) {
        var _dialogRef$current3;
        modalOpen(false);
        dialogRef == null ? void 0 : (_dialogRef$current3 = dialogRef.current) == null ? void 0 : _dialogRef$current3.close();
      }
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "Modal__container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "Modal__close__container",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          onClick: function onClick() {
            var _dialogRef$current4;
            modalOpen(false);
            (_dialogRef$current4 = dialogRef.current) == null ? void 0 : _dialogRef$current4.close();
          },
          className: "Modal__close",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.IconClose, {})
        })
      }), children]
    })
  });
};
var _default = Modal;
exports["default"] = _default;